/*
 * @Author: atdow
 * @Date: 2024-01-08 11:31:36
 * @LastEditors: null
 * @LastEditTime: 2025-07-29 11:30:51
 * @Description: file description
 */
import { convertEnumToArray } from '/@/enums/helper'
import { DataZoomRangePositionEnum } from '/@/components/BaseChart/global'

export const RequestFrontPendingKey = 'rfp' // rfp = request_front_pending_key

export const GLOBAL_COMBINE_KEY = '__sino__' // 全局通用连接符

export const MultiObjectChartXAxisLabelRow = 2 // 多对象x轴label显示行数

export const MultiObjectChartHeight = 228 // 多对象图表高度

export const SinoViewPageTabKey = 'sinoViewPageTabKey'

// 多对象图默认horizontalDataZoomRange
export const MultiObjectChartDefaultHorizontalDataZoomRange = {
  startValue: 0,
  endValue: 11
}

// 多区域图默认horizontalDataZoomRange
export const MultiRegionChartDefaultHorizontalDataZoomRange = {
  startValue: 0,
  endValue: 11
}

export const CommonModuleContainerTitleRow = 1

/**
 * 时间趋势，缩放轴默认展示最新13期（这样至少如果是月度同比的话，能看到去年同期的表现）
 * 时间轴数据：202301 至 202401
 */
export const DateTrendChartDefaultHorizontalDataZoomRange = {
  maxVisibleCount: 13,
  maxVisibleCountDirection: DataZoomRangePositionEnum['RIGHT']
}

/**
 * DEMO示例
 */
export enum VisibleEnum {
  '是' = 1,
  '否' = 0
}

export const VISIBLE_ENUM_LIST = convertEnumToArray(VisibleEnum)

/**
 * 页面模块类型
 */
export enum PageTypeEnum {
  '行业概览' = 'overview',
  '品类洞察' = 'sort',
  '品牌分析' = 'brand',
  '区域分析' = 'region',
  '指标库' = 'indicator',
  '智能助手' = 'aiHelper'
}

export const PAGE_TYPE_ENUM_LIST = convertEnumToArray(PageTypeEnum)

/**
 * 页面模块menuCode(权限菜单)
 */
export enum MenuCodeEnum {
  '行业概览' = '100000',
  '品类洞察' = '200000',
  '品牌分析' = '300000',
  '区域分析' = '500000',
  '指标库' = '400000',
  '智能助手' = '600000'
}

/**
 * 页面模块类型menuCode
 */
export enum PageTypeMenuCodeEnum {
  '行业概览' = 1,
  '品类洞察' = 2,
  '品牌分析' = 3,
  '区域分析' = 5,
  '指标库' = 4,
  '智能助手' = 6,
  '导出中心' = 10000
}

export const PAGE_TYPE_MENU_CODE_ENUM_LIST = convertEnumToArray(PageTypeMenuCodeEnum)

/**
 * 页面模块类型
 */
export enum GlobalSearchComponentTypeEnum {
  '默认' = 'default',
  '新筛选器' = 'new',
}


/**
 * 区域权限类型
 */
export enum RegionPermissionTypeEnum {
  '未开放区域' = 0,
  '权限内区域' = 1,
  '无权限区域' = 2,
}

export const REGION_PERMISSION_TYPE_ENUM_LIST = convertEnumToArray(RegionPermissionTypeEnum)


/**
 * 消费者类型
 */
export enum ConsumerTypeEnum {
  '所有购买者' = 'ALL',
  '会员购买者' = 'MEMBER',
}

export const CONSUMER_TYPE_ENUM_LIST_BY_ALL = [ { label: '所有购买者', value: ConsumerTypeEnum['所有购买者'] } ]

export const CONSUMER_TYPE_ENUM_LIST_BY_MEMBER = [ { label: '会员购买者', value: ConsumerTypeEnum['会员购买者'] } ]

export const CONSUMER_TYPE_ENUM_LIST = convertEnumToArray(ConsumerTypeEnum)

/**
 * 小票类型
 */
export enum SmallTicketEnum {
  'POS小票' = 'ALL',
  '会员小票' = 'MEMBER',
}

export const SMALL_TICKET_ENUM_LIST = convertEnumToArray(SmallTicketEnum)

/**
 * 小票类型(全部)
 */
export enum SmallTicketAllEnum {
  'POS小票' = 'ALL',
  '会员小票' = 'MEMBER',
  '综合小票' = 'MARKET'
}

export const SMALL_TICKET_ENUM_ALL_LIST = convertEnumToArray(SmallTicketAllEnum)

export const NotSupportMarketTicketText = '暂不支持【综合小票】数据类型'

/**
 * 年龄段指标
 */
export enum AgeRangeIndicatorEnum {
  '渗透率' = '0',
  '人数占比' = '1',
}
export const AGE_RANGE_INDICATOR_ENUM_LIST = convertEnumToArray(AgeRangeIndicatorEnum)

/**
 * 季度枚举值
 * Q0: 不限季度， Q1...4: 第一季度...第四季度
 */
export enum QuarterTypeEnum {
  'Q0' = 'Q0',
  'Q1' = 'Q1',
  'Q2' = 'Q2',
  'Q3' = 'Q3',
  'Q4' = 'Q4'
}


/**
 * 趋势图时间纬度枚举
 */
export enum TrendChartTimeDimensionEnum {
  '月度' = 'MONTH',
  '季度' = 'QUARTER',
  'YTD' = 'YTD',
  'MAT' = 'MAT',
  '当期vs对比期趋势' = 'CURRENT_VS_COMPARE'
}

export const TREND_CHART_TIME_DIMENSION_ENUM_LIST = convertEnumToArray(TrendChartTimeDimensionEnum)

/**
 * 趋势图时间纬度枚举(所有)
 */
export enum TrendChartTimeAllDimensionEnum {
  '月度' = 'MONTH',
  '季度' = 'QUARTER',
  '年' = 'YEAR',
  'YTD' = 'YTD',
  'MAT' = 'MAT',
  '当期vs对比期趋势' = 'CURRENT_VS_COMPARE'
}

export const TREND_CHART_TIME_ALL_DIMENSION_ENUM_LIST = convertEnumToArray(TrendChartTimeAllDimensionEnum)

/**
 * 趋势图同环比枚举
 */
export enum TrendChartCompareTypeEnum {
  '同比' = 'TB',
  '环比' = 'HB',
  '默认' = 'DEFAULT'
}

export const TREND_CHART_COMPARE_TYPE_ENUM_LIST = convertEnumToArray(TrendChartCompareTypeEnum)

/**
 * 趋势图对比维度title文案
 */
export enum TrendChartCompareTitleEnum {
  '默认' = '对比'
}

/**
 * 全库通用页面筛选器筛选器检索key
 */
export const PAGE_FILTERS_SEARCH_KEY = 'pageParam'

export enum CurrentVsCompareTrendNameEnum {
  '对比期' = '对比期',
  '当期' = '当期',
}



/**
 * 关键指标枚举
 */
export enum KeyIndicators {
  '同比' = 'TB',
  '环比' = 'HB',
  '默认' = 'DEFAULT'
}

/**
 * 品牌下的品规不限枚举
 */
export enum BrandSpecNoLimitEnum {
  '不限' = '不限',
}

export const BRAND_SPEC_NO_LIMIT_ENUM_LIST = convertEnumToArray(BrandSpecNoLimitEnum)

/**
 * 树图比较类型枚举
 */
export enum CompareTypeEnum {
  '对比增长', // = 'GROWTH_RATE',
  '对比差值'// = 'DIFF',
}

export const COMPARE_TYPE_ENUM_LIST = convertEnumToArray(CompareTypeEnum)

export const COMPARE_TYPE_REVERSE_ENUM_LIST = convertEnumToArray(CompareTypeEnum).reverse()

export enum RepurchaseIndicatorTypeEnum {
  '复购订单量占比',
  '复购销售额占比',
  '复购会员数占比'
}

export const REPURCHASE_INDICATOR_TYPE_ENUM_LIST = convertEnumToArray(RepurchaseIndicatorTypeEnum)

/**
 * 年龄段
 */
export enum AgeGroupEnum {
  '17-25岁',
  '26-35岁',
  '36-45岁',
  '46-55岁',
  '56-65岁',
  '66岁及以上'
}

export const AGE_GROUP_ENUM_LIST = convertEnumToArray(AgeGroupEnum)

/**
 * 年龄段(聚合)
 */
export enum AgeGroupAggregationEnum {
  '17-35岁',
  '36-55岁',
  '56岁及以上',
}

export const AGE_GROUP_AGGREGATION_ENUM_LIST = convertEnumToArray(AgeGroupAggregationEnum)

/**
 * 新老客
 */
export enum NewOldCustomerEnum {
  '全新用户' = 0,
  '新用户',
  '老用户'
}

export const NEW_OLD_CUSTOMER_ENUM_LIST = convertEnumToArray(NewOldCustomerEnum)

export enum FlowTopTypeEnum {
  '总流转次数Top10' = 'TOTAL_TOP',
  '净流入次数Top10' = 'IN_TOP',
  '净流出次数Top10' = 'OUT_TOP'
}

export const FLOW_TOP_TYPE_ENUM_LIST = convertEnumToArray(FlowTopTypeEnum)

export enum SlipTypeEnum {
  '不限' = 'UN_LIMIT',
  '与选定品牌相同通用名' = 'TYM'
}

export const SLIP_TYPE_ENUM_LIST = convertEnumToArray(SlipTypeEnum)

/**
 * 产品颗粒度枚举
 */
export enum ProductParticleSizeEnum {
  '品牌' = 'BRAND',
  '品规' = 'SPEC'
}

export const PRODUCT_PARTICLE_SIZE_ENUM_LIST = convertEnumToArray(ProductParticleSizeEnum)

export enum ProductTypeEnum {
  '明星产品',
  '高端产品',
  '大众产品',
  '培育产品',
}

export const PRODUCT_TYPE_ENUM_LIST = convertEnumToArray(ProductTypeEnum)

export enum ProductTypeDescEnum {
  '明星品牌' = '品牌销售额占比≥Top20品牌平均销售额占比，品牌渗透率≥Top20品牌平均渗透率',
  '大众品牌' = '品牌销售额占比＜Top20品牌平均销售额占比，品牌渗透率≥Top20品牌平均渗透率',
  '培育品牌' = '品牌销售额占比＜Top20品牌平均销售额占比，品牌渗透率＜Top20品牌平均渗透率',
  '高端品牌' = '品牌销售额占比≥Top20品牌平均销售额占比，品牌渗透率＜Top20品牌平均渗透率'
}

export const PRODUCT_TYPE_DESC_ENUM_LIST = convertEnumToArray(ProductTypeDescEnum)

export const ProductTypeDescReminder = [
  '各产品类型定义如下：',
  ...PRODUCT_TYPE_DESC_ENUM_LIST.map(item => `· ${item.label}：${item.value}`)
].join('<br/>')

export enum ShelfSalesIndicatorTypeEnum {
  '销售额占比',
  '店均订单量',
}

export const SHELF_SALES_INDICATOR_TYPE_ENUM_LIST = convertEnumToArray(ShelfSalesIndicatorTypeEnum)

/**
 * 标准区域类型枚举
 */
export enum StandardRegionTypeEnum {
  '全国' = 'COUNTRY',
  '省份' = 'PROVINCE',
  '大区' = 'AREA',
  '城市' = 'CITY',
  '自定义大区' = 'CUSTOM_AREA',
}

export const STANDARD_REGION_TYPE_ENUM_LIST = convertEnumToArray(StandardRegionTypeEnum)

/**
 * 自定义大区status枚举
 */
export enum CustomizedRegionStatusEnum {
  '可用' = 1,
  '不可用' = 0
}

/**
 * 绿涨红跌trendBaseValue枚举
 */
export enum TrendBaseValueEnum {
  '默认' = 0,
  '增长指数' = 100
}

export const BrandSearchDataCompareTypeListKey = 'brandCompareTypeList'

/**
 * 品牌-检索-对比类型
 */
export enum BrandSearchDataCompareTypeEnum {
  '本品' = 'CURRENT',
  '对比品牌' = 'COMPARE',
  '其他品牌' = 'OTHER'
}

/**
 * 城市等级枚举
 */
export enum CityLevelEnum {
  'T1' = 'T1',
  'T2' = 'T2',
  'T3' = 'T3',
  'T4' = 'T4',
  'T5' = 'T5',
  'T6' = 'T6'
}

export const CITY_LEVEL_ENUM_LIST = convertEnumToArray(CityLevelEnum)

/**
 * 连锁等级枚举
 */
export enum ChainLevelEnum {
  '大型连锁' = '大型连锁',
  '中型连锁' = '中型连锁',
  '小型连锁' = '小型连锁'
}

export const CHAIN_LEVEL_ENUM_LIST = convertEnumToArray(ChainLevelEnum)

/**
 * 门店等级枚举
 */
export enum StoreLevelEnum {
  'A级店' = 'A',
  'B级店' = 'B',
  'C级店' = 'C',
  'D级店' = 'D'
}

export const Store_LEVEL_ENUM_LIST = convertEnumToArray(StoreLevelEnum)

/**
 * 页面chartMode
 */
export enum ViewChartModeEnum {
  'AI助手' = 'AiHelper',
  '页面' = 'viewPage'
}

/**
 * 品牌类型
 */
export enum BrandTypeEnum {
  '标准'= 0,
  '自定义' = 1
}

export const BRAND_TYPE_ENUM_LIST = convertEnumToArray(BrandTypeEnum)

/**
 * 品牌品规类型
 */
export enum BrandSpecTypeEnum {
  '品牌'= 'BRAND',
  '品规' = 'BRAND_SPEC'
}

